import { UNLOCKED_EXTRA_FREE_SAMPLES_COUNT_TIER } from 'modules/cart/constants'

/**
 * @param unlockedExtraFreeSamplesTier
 * @returns {boolean}
 */
const hasUnlockedExtraFreeSamplesCartSelectUtil = ({
  unlockedExtraFreeSamplesTier
}) => {
  return unlockedExtraFreeSamplesTier !== UNLOCKED_EXTRA_FREE_SAMPLES_COUNT_TIER.ABOVE_0
}

export default hasUnlockedExtraFreeSamplesCartSelectUtil
